import LinkOrButton from "./LinkOrButton";

export default LinkOrButton;
